export default {
  //授课签到
  SKYXtaskList: '',
  //预习详情
  SKYXtaskDetails:'',
  //预习测验详情
  SKYXtaskListDetail:'',
  //学生疑惑留言
  SKYXtaskStuRootMessage:'',
}



// WEBPACK FOOTER //
// ./src/store/give-course/yxTask/states.js